module.exports = __webpack_public_path__ + "img/a4.202f3aca.jpg";